module.exports = __webpack_public_path__ + "static/media/jim-kekatos.b763a4c4.png";